import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { catchError, map, Observable, of, take } from 'rxjs'
import { DdcLoggerService } from '../service/log/ddc-logger.service'
import { UserService } from '../service/user-info/user.service'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private logger: DdcLoggerService,
    private userService: UserService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    this.logger.info('AuthGuard: canActivate()')

    return this.userService.checkAuth().pipe(
      take(1),
      map((userInfo: any) => {
        if (userInfo && userInfo.username) {
          return true
        }
        this.logger.warn('AuthGuard: Not authenticated, redirecting to /login')
        this.router.navigate(['/login'])
        return false
      }),
      catchError(() => {
        this.router.navigate(['/login'])
        return of(false)
      }),
    )
  }
}
